<template>
  <div style="min-height: 100vh">
    <v-overlay absolute :opacity="0.75" v-if="loading">
      <div class="text-center">
        <v-progress-circular :size="100" indeterminate></v-progress-circular>
        <div class="caption mt-4">Loading</div>
      </div>
    </v-overlay>
    <transition name="slide-x-reverse-transition">
      <v-container id="applicant-view" v-if="!loading && applicant.name">
        <v-row justify="center">
          <v-col cols="11" sm="10" md="9" lg="8" xl="6">
            <v-container>
              <div>
                <v-row justify="center" style="position: relative">
                  <v-col
                    cols="12"
                    sm="11"
                    md="10"
                    lg="9"
                    xl="7"
                    class="text-center"
                  >
                    <div>
                      <img
                        :title="applicant.portal.logo.name"
                        :src="applicant.portal.logo.url"
                        style="width: 100%; max-width: 375px; height: auto"
                        @click="$emit('logo-upload')"
                      />
                    </div>
                  </v-col>
                  <v-col cols="12" v-if="applicant.portal.video">
                    <video
                      playsinline
                      style="
                        width: 100%;
                        height: auto;
                        max-height: 66vh;
                        margin-bottom: -8px;
                      "
                      :src="applicant.portal.video.url"
                      :poster="applicant.portal.video.thumbnail"
                      controls
                    ></video>
                  </v-col>
                </v-row>
              </div>
              <div
                id="portal-info"
                v-if="applicant.portal.title || applicant.portal.description"
              >
                <v-row>
                  <v-col cols="12">
                    <h3>{{ applicant.portal.title }}</h3>
                    <p class="caption">{{ applicant.portal.description }}</p>
                  </v-col>
                </v-row>
              </div>

              <div id="applicant-info">
                <v-row justify="center">
                  <v-col cols="12" class="py-2">
                    <v-text-field
                      dense
                      outlined
                      hide-details
                      name="name"
                      label="Name"
                      :value="applicant.name"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="py-2">
                    <v-text-field
                      dense
                      outlined
                      hide-details
                      readonly
                      name="email"
                      label="Email"
                      type="email"
                      :value="applicant.email"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="py-2" v-if="applicant.phone">
                    <v-text-field
                      dense
                      outlined
                      hide-details
                      name="phone"
                      label="Phone #"
                      type="tel"
                      readonly
                      :value="applicant.phone"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </div>

              <div id="portal-sections">
                <v-row>
                  <v-col
                    cols="12"
                    v-for="(section, s) in applicant.sections"
                    :key="s"
                  >
                    <portal-section
                      :value="section"
                      :readonly="true"
                    ></portal-section>
                  </v-col>
                </v-row>
              </div>

              <div id="portal-submit">
                <v-row justify="space-around">
                  <v-col class="text-center" cols="12">
                    <v-btn
                      x-large
                      :to="`/applicant-link/${applicant.portal.applicant_uid}`"
                      >Go To Portal</v-btn
                    >
                  </v-col>
                </v-row>
              </div>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </transition>
  </div>
</template>

<script>
import portalSection from "@/components/portal/applicant-view/section";

export default {
  name: "Applicant",
  components: {
    portalSection,
  },
  data() {
    return {
      loading: false,
      applicant: { sections: [], portal: {} },
    };
  },
  computed: {},
  async created() {
    this.loading = true;
    await this.load();
    this.loading = false;
  },
  methods: {
    async load() {
      try {
        let response = await this.$api(`/applicant/${this.$route.params.uid}`);
        this.applicant = response;
        console.log("isProcessing", this.$helpers.isProcessing(this.applicant));
        if (this.$helpers.isProcessing(this.applicant)) {
          setTimeout(this.load, 3000);
        }
      } catch (ex) {
        alert(ex.error);
        this.$router.push("/");
      }
    },
  },
};
</script>

<style>
</style>